const MIN_LENGTH = 2;

const formatNumber = (value = 0) => addTrailingZero(value.toString());

const addTrailingZero = (value: string) => value.padStart(MIN_LENGTH, '0');

export default formatNumber;
